module.exports = __webpack_public_path__ + "static/img/5.d17fba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-terrestre-carga/5.png
// module id = nZEs
// module chunks = 0